
    import { makeI18n } from '@/shared/lib/i18n';
    import baseTranslation from "/app/src/modules/auth-type.lang.json"
    
    
    if(module.hot) {
      const bucket = require("/app/build/i18n/browser-bucket.js");
      bucket.add('src/shared/legacy/ui/integration/integration.vue', {"connect":{"ru_RU":"Подключить","en_US":"Connect"},"disconnect":{"ru_RU":"Отключить","en_US":"Disconnect"}}) 
    }
   
    
    export default function (Component) {
      function beforeCreateI18n() {
        this.$i18n = this.$options._i18n;
      }

      function addHook(current) {
        if (Array.isArray(current)) {
          return [beforeCreateI18n].concat(current);
        } 
        if (current) {
          return [beforeCreateI18n, current];
        }
        return [beforeCreateI18n];
      }
    
      Component._i18n = makeI18n("src/shared/legacy/ui/integration/integration.vue", baseTranslation);
      Component.beforeCreate = addHook(Component.beforeCreate);
      delete Component._Ctor;
    }
  